import React from 'react';
import RolePrivateRoute from 'src/components/PrivateRotes/RolePrivateRoute';
import BillingListView from './BillingList';

const BillingView = () => {
  return (
    <>
      <RolePrivateRoute component={BillingListView} />
    </>
  );
};


export default BillingView;
